import CityPageMosquiteras from "../components/CityPageMosquiteras";

export default function Page() {
  return (
    <CityPageMosquiteras
      name="Vélez-Málaga"
      slug="velez-malaga"
      cp="29700"
      poblacion={87798}
      zonaGeo="Axarquía"
      lat={36.7798}
      lng={-4.1027}
      zonas={["Torre del Mar", "Vélez Centro", "Caleta de Vélez", "Almayate"]}
      landmarks={["Torre del Mar", "Fortaleza de Vélez"]}
      municipiosLimitrofes={["Algarrobo", "Torrox", "Benamargosa"]}
      festivalLocal="Real Feria de San Miguel (septiembre)"
      contextoTipologico="Capital de la Axarquía, Torre del Mar con apartamentos costeros, zonas agrícolas circundantes con presencia intensa de mosquitos en verano."
      isCoreZone={false}
    />
  );
}